export enum PathsEnum {
  home = '',
  customers = 'customers',
  registerWorkstation = 'register-workstation',
  cashPoint = 'cashpoint',
  wildCard = '**'
}
